export interface SEOData {
  page_title: string;
  page_description: string;
  page_canonical_url: string;
  keywords: string;
  page_og_title: string;
  page_og_description: string;
  page_og_url: string;
  twitter_title: string;
  twitter_description: string;
  twitter_image: string;
  twitter_image_alt: string;
  article_modified_time: string | null;
  article_published_time: string | null;
}
export const seoClgAndExamPageUtils = (
  seoData: any[],
  data?: string,
  id?: string,
  type?: string,
  tab?: string,
  isOnlineCollege?: boolean,
  imageUrl?: string,
  imageAlt?: string,
  updatedAt?: string,
  publishedAt?: string
): SEOData => {
  const baseUrl = process.env.NEXT_PUBLIC_DOMAIN_URL?.replace(/\/$/, "") ?? "";

  const sectionName = (str: string) =>
    str
      .split("-")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const canonical_url = isOnlineCollege
    ? `${baseUrl}/${type}/${id}`
    : `${baseUrl}/${type}/${id}/${tab}`;

  const seo = Array.isArray(seoData) && seoData.length === 1 ? seoData[0] : {};

  const fallbackTitle = `${data} | ${sectionName(tab ?? "")} - CollegeHai`;
  const fallbackDesc = `Find detailed information about ${data} including ${sectionName(
    tab ?? ""
  )}, eligibility, admission, fees, placements, and more.`;

  return {
    page_title: seo.page_title || fallbackTitle,
    page_description: seo.page_description || fallbackDesc,
    page_canonical_url: canonical_url,
    keywords:
      seo.keywords ||
      `${data} ${tab} details, ${data} college information, college admission, education India`,
    page_og_title: seo.page_og_title || seo.page_title || fallbackTitle,
    page_og_description:
      seo.page_og_description || seo.page_description || fallbackDesc,
    page_og_url: canonical_url,
    twitter_title: seo.twitter_title || fallbackTitle,
    twitter_description: seo.twitter_description || fallbackDesc,
    twitter_image: imageUrl ?? `${baseUrl}/images/logo.png`,
    twitter_image_alt: imageAlt ?? `${data} Thumbnail`,
    article_modified_time: updatedAt ?? null,
    article_published_time: publishedAt ?? null,
  };
};
